import React, { memo, HTMLProps, useState, useEffect } from "react";
import classnames from "classnames";
import { ImgUtils, Logger } from "src/utils";
import { Element } from "../base";
import { PLACE_HOLDER } from "@zmedia/bm-common/constants";

interface IProps extends HTMLProps<HTMLImageElement> {
    src: string;
    alt?: string;
    size?: number;
    rounded?: boolean;
    className?: string;
    renderAs?: string;
    children?: React.ReactNode;
}

const Image = React.forwardRef(
    (
        {
            src = "",
            alt = "",
            size,
            rounded,
            className,
            children,
            renderAs = "figure",
            width,
            height,
            ...rest
        }: IProps,
        ref
    ) => {
        const [supportWebp, setSupportWebp] = useState<boolean>(false);
        const [error, setError] = useState<boolean>(false);

        const onError = () => {
            setError(true);
            Logger.errorImage("Error loadImage fail|src:", { _src, alt });
        };

        useEffect(() => {
            setSupportWebp(ImgUtils.isSupportWebp());
        }, []);

        const _src = supportWebp ? ImgUtils.convertToWebp(src) : src;

        return (
            <Element
                {...rest}
                domRef={ref}
                renderAs={renderAs}
                className={classnames(
                    "image",
                    {
                        "is-rounded": rounded,
                    },
                    className
                )}
            >
                {_src && (
                    <img
                        src={error ? PLACE_HOLDER.IMAGE :_src}
                        alt={alt}
                        width={width}
                        height={height}
                        onError={onError}
                    />
                )}
            </Element>
        );
    }
);

export default memo(Image);
